import { Http } from '../../../support';

const initialState = {
  busy: false,
  data: [],
  filters: {
    page: 1,
    search: '',
  },
  error: undefined,
  selectable: false,
  selectedRowKeys: [],
  selectedRows: [],
  pagination: {
    limit: 25,
  },
};

const paginate = async (store, meta = {}) => {
  store.setState((state) => {
    state.modulo.timbrado_sftp.list = {
      ...state.modulo.timbrado_sftp.list,
      error: undefined,
      busy: true,
      pagination: {
        ...state.modulo.timbrado_sftp.list.pagination,
        ...meta,
      },
    };
  });

  try {
    const { pagination } = store.state.modulo.timbrado_sftp.list;

    const params = {
      ...pagination,
      ...meta,
    };

    const response = await Http.get('api/timbrado-tickets', { params });

    store.setState((state) => {
      state.modulo.timbrado_sftp.list = {
        ...state.modulo.timbrado_sftp.list,
        busy: false,
        data: response.data,
        pagination: {
          ...state.modulo.timbrado_sftp.list.pagination,
          ...response.meta.pagination,
          links: undefined,
        },
        filters: {
          ...params,
          from: params.from,
          to: params.to,
        },
      };
    });
  } catch (error) {
    store.setState((state) => {
      state.modulo.timbrado_sftp.list.busy = false;
      state.modulo.timbrado_sftp.list.error = error.data || error;
    });
  }
};

const resetError = (store) => (state) => {
  state.modulo.timbrado_sftp.list.error = undefined;
};

const setSelectable = (store, selectable) => (state) => {
  state.modulo.timbrado_sftp.list.selectable = selectable;
};

const setSelection = (store, selectedRows, selectedRowKeys) => {
  return (state) => {
    state.modulo.timbrado_sftp.list = {
      ...state.modulo.timbrado_sftp.list,
      selectedRows: selectedRows,
      selectedRowKeys: selectedRowKeys,
    };
  };
};

const clearSelection = () => {
  return (state) => {
    state.modulo.timbrado_sftp.list = {
      ...state.modulo.timbrado_sftp.list,
      selectable: false,
      selectedRowKeys: [],
      selectedRows: [],
    };
  };
};

const actions = {
  paginate,
  resetError,
  setSelectable,
  setSelection,
  clearSelection,
};

const TimbradoSftpListStore = {
  state: () => initialState,
  actions,
};

export default TimbradoSftpListStore;
